import React from "react";
import { Card, Stack, TextStyle } from "@shopify/polaris";
import { getPasswordCriteriaState } from "lib/helpers/passwordCriteria";

const PasswordRequirements = ({ password = "", isTouched = false }) => {
  const criteriaState = getPasswordCriteriaState(password);

  return (
    <Card sectioned>
      <Stack vertical spacing="tight">
        <TextStyle variation="strong">PASSWORD REQUIREMENTS:</TextStyle>
        {criteriaState.map((criteria) => {
          const isCriteriaFailed = isTouched && !criteria.isValid;
          const icon = criteria.isValid ? "\u2713" : "\u2715";
          const variation = criteria.isValid ? "positive" : isCriteriaFailed ? "negative" : "subdued";

          return (
            <Stack key={criteria.key} spacing="tight" alignment="center">
              <TextStyle variation={variation}>{icon}</TextStyle>
              <TextStyle variation={variation}>{criteria.label}</TextStyle>
            </Stack>
          );
        })}
      </Stack>
    </Card>
  );
};

export default PasswordRequirements;
